import { Injectable } from '@angular/core';
import { ListHelperService, StoreService } from 'core/services';
import { TranslateService } from '@ngx-translate/core';
import { TableDatasource, DataTypes } from '@gamelearn/skeletor/models';
import { Cache } from 'core/models';

@Injectable()
export class MarsDebateOpinionsListService {
  userRole: any;
  dataSource: TableDatasource;

  constructor(public translate: TranslateService, public listHelper: ListHelperService) {}

  getDatasource(listId, opinionsCache: Cache) {
    const dataSource = new TableDatasource({
      sort: '-created_at',
      columns: this.getColumns(),
      page: 1,
      pages: 1,
      limit: opinionsCache.data.length,
      total: opinionsCache.data.length,
      load: (props) => this.fetch(props, opinionsCache)
    });
    dataSource.refreshData();
    StoreService.create(listId, dataSource);
    return dataSource;
  }

  fetch(options, opinionsCache: Cache) {
    return opinionsCache.fetch(options).then((opinions) => this.searchOpinions(opinions, options));
  }

  searchOpinions(opinions, options) {
    const { search } = options;
    if (!search) {
      return opinions;
    } else {
      const searchTerm = search.toLowerCase();
      const filteredOpinions = opinions.docs.filter(
        (opinion) =>
          (opinion.debateText && opinion.debateText.toLowerCase().includes(searchTerm)) ||
          (opinion.authorEmail && opinion.authorEmail.toLowerCase().includes(searchTerm))
      );
      return {
        docs: filteredOpinions,
        page: 1,
        pages: 1,
        total: filteredOpinions.length
      };
    }
  }

  getColumns() {
    const columns = [
      {
        source: 'debateText',
        label: this.translate.instant('debates.opinions'),
        dataType: DataTypes.string,
        sortable: true
      },
      {
        source: 'created_at',
        label: this.translate.instant('debates.datetime'),
        dataType: DataTypes.datetime,
        sortable: true
      },
      {
        source: 'vote',
        label: this.translate.instant('debates.vote'),
        dataType: DataTypes.string,
        sortable: false,
        cellRenderer: (renderer, value) => {
          if (!value) {
            return renderer`--`;
          }

          const isPositiveVote = value === 'positive';
          const voteIcon = isPositiveVote ? 'glicon-thumb-up' : 'glicon-thumb-down';
          const voteColor = isPositiveVote ? '--success' : '--error';
          const voteLabel = isPositiveVote
            ? this.translate.instant('debates.positiveVote')
            : this.translate.instant('debates.negativeVote');

          return renderer`
            <gl-icon style="color: var(${voteColor});font-size: 20px" icon="${voteIcon}"></gl-icon>
            <span style="margin: var(--gap)">${voteLabel}</span>
          `;
        }
      },
      {
        source: 'authorEmail',
        label: this.translate.instant('debates.author'),
        dataType: DataTypes.string,
        sortable: true
      }
    ];
    return columns;
  }
}
